import { ChangeDetectorRef } from "@angular/core";

export namespace S25AngJs {
    // Subscribe to changes to an object's property
    // This is useful when AngularJS changes a model's properties outside the Angular zone
    // such that angular cannot detect the change right away
    export function detectPropertyChanges(
        model: { [key: string]: any },
        property: string,
        changeDetector: ChangeDetectorRef,
    ) {
        onPropertyChange(model, property, () => changeDetector.detectChanges());
    }

    // Subscribe to changes to an object's property
    // This is useful when AngularJS changes a model's properties outside the Angular zone
    // such that angular cannot detect the change right away
    export function onPropertyChange<T>(
        model: { [key: string]: any },
        property: string,
        callback: (newValue?: T, oldValue?: T) => void,
    ) {
        if (!model) return;
        let value = model[property];

        const oldSet = Object.getOwnPropertyDescriptor(model, property)?.set;
        const oldGet = Object.getOwnPropertyDescriptor(model, property)?.get;

        const set = (newValue: T) => {
            const oldValue = value;
            value = newValue;
            callback(newValue, oldValue);
            oldSet?.(newValue);
        };
        const get = () => {
            oldGet?.();
            return value;
        };

        Object.defineProperty(model, property, {
            configurable: true,
            set(newValue: any) {
                return set(newValue);
            },
            get() {
                return get();
            },
        });
    }
}
